import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
 selector: 'formly-text-only-field',
 template: `
    <span [innerHTML]="currValue"></span>
    <input type="hidden" [value]="currValue" class="wcag-visuallyhidden" [id]="elementId"/>
  `,
})
export class FormlyFieldTextOnlyFieldComponent extends FieldType implements OnInit {

  public translatePrefix;
  public type;

  constructor(
    private translateService: TranslateService,
  ) {
    super();
  }

  ngOnInit() {
    this.translatePrefix = this.props.translatePrefix ? `${ this.props.translatePrefix }.` : '';
    this.type = this.props.type;
  }

  get elementId(): string {
    if (this.field.id && this.field.id.includes('formly_')) {
      let prefix = this.form['id'];

      // check if in repeat section
      if (!prefix && this.field.parent.parent && this.field.parent.parent.parent && this.field.parent.parent.parent.type === 'repeat') {
        const cnt = this.field.parent.parent.key;
        prefix = `${this.field.parent.parent.parent['id']}_${cnt}`;
      }

      return `${prefix ? prefix + '_' : ''}${(this.key as string).replace('.', '_')}`;
    } else {
      return this.field.id;
    }
  }

  get currValue() {
    if (this.props.translate) {
      const translatedValue = this.model[this.field.key as string] ? this.translateService.instant(`${this.translatePrefix}${this.model[this.field.key as string]}`) : '';
      return translatedValue !== `${this.translatePrefix}${this.model[this.field.key as string]}` ? translatedValue : this.model[this.field.key as string];
    } else {
      return this.model && this.model[this.field.key as string];
    }
  }

}
